import { Image } from '@finn/ui-components';
import {
  getCloudinaryImgUrl,
  getFormattedPrice,
  useIntl,
} from '@finn/ui-utils';

import { Skeleton } from '../../../components/Skeleton';
import { useDeal } from '../../../hooks/useDeal';
import { useDealId } from '../../../providers/MetadataProvider';

export const ProductCardBlock = () => {
  const dealId = useDealId();
  const { data: deal, status } = useDeal(dealId);
  const i18n = useIntl();

  const src = deal?.car?.picture
    ? getCloudinaryImgUrl(deal?.car?.picture, {
        c: 'fill',
        dpr: 2,
        fl: 'progressive',
      })
    : null;

  if (status === 'loading') {
    return (
      <Skeleton loading fullWidth height="310px">
        <div />
      </Skeleton>
    );
  }

  return (
    <div className="flex w-[316px] flex-col items-center gap-3 self-center">
      {src ? (
        <Image
          src={src || ''}
          alt={deal?.car?.oem}
          width={316}
          className="bg-snow"
        />
      ) : (
        <Skeleton loading fullWidth height="187px">
          <div />
        </Skeleton>
      )}
      <p className="self-start body-16-semibold">
        {deal?.car?.oem} {deal?.car?.model}
      </p>
      <div className="flex items-center justify-start gap-1 self-start">
        <p className="body-14-light">{deal?.car?.trim}</p>
        <div className="size-0.5 rounded bg-pewter" />
        <p className="body-14-light">{deal?.car?.fuel}</p>
      </div>
      <p className="self-start body-14-semibold">
        {getFormattedPrice(i18n, deal?.amount || NaN, 0)}{' '}
        <span className="body-14-light before:hidden after:hidden">
          pro Monat
        </span>
      </p>
    </div>
  );
};
